import React from 'react';
import styled from 'styled-components';
import cssConstants from '../../constants/cssConstants';
import {conversationsStore} from '../../context/conversationsProvider';
import withMemoizedContexts from '../../context/contextContainerHoC';

export const ButtonGroupWrapper = styled.div`
   display: flex;
   flex-direction: row;
   z-index: ${cssConstants.zIndex.viewPageElement};
`;

const ButtonWrapper = styled.div`
   margin: 0 0.25rem;

   a {
      margin-right: 0;
   }
`;

const PrimaryButtonWrapper = styled(ButtonWrapper)<{breakpoint: number}>`
   order: 1;

   span:nth-child(1) {
      display: none;
   }

   span:nth-child(2) {
      display: block;
      margin-left: 0;
   }

   @media screen and (max-width: ${props => props.breakpoint}px){
      order: -1;
      margin-left: 0;

      button {
         padding: 0.5rem;
      }

      span:nth-child(1) {
         display: block;
      }

      span:nth-child(2) {
         display: none;
      }
   }
`;

export const ConversationActionsButtonGroupBase: React.FC<IDataTableActionButtonGroupProps & IStateMappedProps> = ({primaryButton, otherButtons, conversationPaneOpen}) => {
   const breakpoint = cssConstants.tableBreakpoint(conversationPaneOpen);

   return (<ButtonGroupWrapper>
      {otherButtons.map((b, i) => <ButtonWrapper key={`${b.key}-${i}`}>{b}</ButtonWrapper>)}
      <PrimaryButtonWrapper breakpoint={breakpoint}>{primaryButton}</PrimaryButtonWrapper>
   </ButtonGroupWrapper>);
};

export interface IDataTableActionButtonGroupProps {
   primaryButton: React.ReactElement;
   otherButtons: React.ReactElement[];
}

export interface IStateMappedProps {
   conversationPaneOpen: boolean;
}

const mapStatesToProps = (props: IDataTableActionButtonGroupProps, {conversationPaneOpen}: IStateMappedProps): IDataTableActionButtonGroupProps & IStateMappedProps => ({conversationPaneOpen, ...props});

export default withMemoizedContexts(mapStatesToProps, conversationsStore)(ConversationActionsButtonGroupBase);